import { apiRequest } from './http-service'

export type Language = { id: string, description: string }
export type Snapshot = { id: number, content: unknown }

async function getLanguages() {
  return apiRequest<Language[]>('GET', 'snapshot/languages')
}

async function getSnapshots() {
  return apiRequest<Snapshot[]>('GET', 'snapshot')
}

async function getSnapshot(id: string) {
  return apiRequest<Snapshot>('GET', `snapshot/${id}`)
}

async function createSnapshot(requestId: string, culture: string) {
  return apiRequest<Snapshot>('POST', 'snapshot', { params: { requestId, culture } })
}

async function updateSnapshot(snapshot: Snapshot) {
  return apiRequest<Snapshot>('PUT', 'snapshot', { data: snapshot })
}

async function deleteSnapshot(snapshotId: number) {
  return apiRequest('DELETE', `snapshot/${snapshotId}`)
}

export { getLanguages, getSnapshots, getSnapshot, createSnapshot, deleteSnapshot, updateSnapshot }
